module.exports = __webpack_public_path__ + "img/sj.0b74d901.svg";